module.exports = __webpack_public_path__ + "img/home-production-04.0abc747f.png";